import * as Switch from "@radix-ui/react-switch";
import styles from "./Toggle.module.css";

interface ToggleProps {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => Promise<void> | void;
  disabled?: boolean;
  loading?: boolean;
  defaultChecked?: boolean;
  required?: boolean;
  name?: string;
  value?: string;
  id?: string;
  "aria-label"?: string;
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onCheckedChange,
  disabled = false,
  loading = false,
  defaultChecked,
  required,
  name,
  value,
  id,
  "aria-label": ariaLabel,
}: ToggleProps) => {
  const handleCheckedChange = async (newChecked: boolean) => {
    if (onCheckedChange) {
      await onCheckedChange(newChecked);
    }
  };

  return (
    <Switch.Root
      className={`${styles.toggleRoot} ${loading ? styles.loading : ""}`}
      checked={checked}
      onCheckedChange={handleCheckedChange}
      disabled={disabled || loading}
      defaultChecked={defaultChecked}
      required={required}
      name={name}
      value={value}
      id={id}
      aria-label={ariaLabel}
    >
      <Switch.Thumb className={styles.toggleThumb} />
    </Switch.Root>
  );
};

export default Toggle;
